import { render } from "./HelpDesk.vue?vue&type=template&id=f7a9953e"
import script from "./HelpDesk.vue?vue&type=script&lang=js"
export * from "./HelpDesk.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__